"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDonutConfiguration = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var merge_1 = tslib_1.__importDefault(require("lodash/merge"));
var pieConfiguration_1 = require("../pieChart/pieConfiguration");
var helpers_1 = require("../_chartCreators/helpers");
function getDonutConfiguration(config) {
    return merge_1.default({}, pieConfiguration_1.getPieConfiguration(config), {
        chart: {
            events: {
                load: function () {
                    var _a, _b, _c, _d, _e;
                    this.series[0].update({
                        dataLabels: {
                            distance: -(((_d = (_c = (_b = (_a = this.series[0].points) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.shapeArgs) === null || _c === void 0 ? void 0 : _c.r) !== null && _d !== void 0 ? _d : 40) * 0.25),
                        },
                    });
                    helpers_1.alignChart(this, (_e = config.chart) === null || _e === void 0 ? void 0 : _e.verticalAlign);
                },
            },
        },
        plotOptions: {
            pie: {
                innerSize: "50%",
            },
        },
    });
}
exports.getDonutConfiguration = getDonutConfiguration;
//# sourceMappingURL=donutConfiguration.js.map